// src/components/Footer.jsx
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <p>© 2025, University of South Florida. All rights reserved.</p>
      <p>This website is maintained by Muma College of Business.</p>
      <p>4202 E. Fowler Avenue, BSN 3403, Tampa, FL 33620, USA | 813-974-4281</p>
    </footer>
  );
};

export default Footer;
